/**
 * @file main.tsx
 * @description Точка входа React-приложения @chaiberi/admin (phase08.5 shadcn).
 *
 * Stack: Vite 6 + React 19 + Tailwind 4 + shadcn (исходники в `components/ui/`)
 * + @base-ui/react + lucide-react + sonner. MUI v9 удалён.
 *
 * Шрифты: Inter (текст) + JetBrains Mono (номера документов, артикулы, коды
 * ячеек) — оба self-hosted через @fontsource, латиница + кириллица.
 * До phase19.24 моно-стек был системным (Consolas / Menlo / Roboto Mono),
 * поэтому номера выглядели по-разному в каждой ОС.
 * Иконки: lucide-react (tree-shakable, заменили Material Symbols 5.3 MB).
 *
 * Стили: `./index.css` подгружает Tailwind и правила кабинетов; палитру темы
 * ставит `lib/cabinet-theme-boot` до первого кадра (phase19.31).
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/cyrillic-400.css";
import "@fontsource/inter/cyrillic-500.css";
import "@fontsource/inter/cyrillic-600.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/cyrillic-400.css";
import "@fontsource/jetbrains-mono/cyrillic-500.css";

import { App } from "./App";
import { bootCabinetTheme, syncBootTheme } from "./lib/cabinet-theme-boot";
import { router } from "./router";
import { Toaster } from "./components/ui/NotifyProvider";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Не найден #root в index.html — приложение не может смонтироваться.");
}

// Тема кабинета — до первого кадра: правила + палитра по адресу (магазин — из
// кэша своей темы, остальное — «Commora»); вне магазина после навигаций — «Commora».
bootCabinetTheme();
router.subscribe((state) => syncBootTheme(state.location.pathname));

createRoot(rootElement).render(
  <StrictMode>
    <App />
    <Toaster />
  </StrictMode>,
);
